var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPydantic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo astro-idrpryed",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.12 119.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.124 90.3894L73.3707 2.06782C71.3644 -0.689272 66.7379 -0.689272 64.7515 2.06782L0.998173 90.3894C0.349361 91.2918 0 92.3787 0 93.4905C0 95.7789 1.47231 97.8181 3.64333 98.541L67.3966 119.391H67.4066C68.4747 119.74 69.6326 119.74 70.7006 119.391H70.7106L134.464 98.541C136.076 98.0125 137.344 96.7561 137.858 95.1358C138.392 93.5254 138.112 91.7704 137.109 90.3894H137.124ZM69.0636 14.2379L94.6168 49.6413L70.7206 41.8287C70.5359 41.7689 70.3413 41.7789 70.1566 41.734C69.9719 41.6842 69.7923 41.6642 69.6076 41.6443C69.4229 41.6193 69.2483 41.5495 69.0636 41.5495C68.8789 41.5495 68.7092 41.6193 68.5246 41.6443C68.3399 41.6642 68.1553 41.6941 67.9756 41.734C67.7859 41.7689 67.5913 41.7689 67.4216 41.8287L43.6701 49.5964L43.5203 49.6463L69.0736 14.2379H69.0636ZM32.9597 64.2644L60.7788 55.1605L63.7483 54.1933V107.032L13.8696 90.7135L32.9597 64.2644ZM74.3839 107.022V54.1933L105.173 64.2644L124.263 90.6985L74.3789 107.022H74.3839Z",
    fill: "#E620E9",
    className: "astro-idrpryed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPydantic);
export default __webpack_public_path__ + "static/media/pydantic.9bfa3dac98454b0d135d554a05fca006.svg";
export { ForwardRef as ReactComponent };